const translate = (component, key, language = 'en') => {
  const translations = {
    tr: {
      about: {
        title: "HAKKIMIZDA",
        subtitle: "Esnek BT hizmetleri sunuyoruz",
        whoWeAre: "Biz Kimiz",
        companyName: "AlpineSoft",
        description1: "İsviçre merkezli yazılım şirketimiz, Türkiye'deki şubesiyle, farklı sektörlere özel teknoloji çözümleri sunmaktadır. Yazılım geliştirme, dijital dönüşüm, bulut teknolojileri ve veri analitiği gibi alanlarda yenilikçi hizmetler sunarak, müşterilerimizin iş süreçlerini daha verimli hale getiriyoruz. Global deneyimimiz ve yerel çözümlerimizle, iş ortaklarımıza sürdürülebilir başarı sağlamak için sürekli gelişim ve teknolojiye odaklanıyoruz. Geleceği şekillendiren yazılımlarımızla iş dünyasında fark yaratıyoruz.",
        description2: "Yolculuğumuz, dijital uçurumu kapatma ve çeşitli sektörlerdeki işletmeleri güçlendiren anlamlı teknolojik çözümler yaratma vizyonuyla başladı. Bugün, yazılım geliştirme ve veri analitiğinden siber güvenlik ve dijital pazarlamaya kadar güvenilir BT hizmetleri arayan kuruluşlar için güvenilir bir ortak olarak duruyoruz.",
        description3: "Bizi farklı kılan, hem teknik mükemmeliyete hem de ekonomik güçlendirmeye olan bağlılığımızdır. Uzman profesyonellerden oluşan ekibimiz, her projeye çeşitli bakış açıları ve uzmanlık getirerek, yalnızca teknik olarak sağlam değil, aynı zamanda müşterilerimizin stratejik hedefleriyle uyumlu çözümler sunar.",
        feature1Title: "%100 Siyah Sahipli Girişim",
        feature1Description: "Güney Afrika'nın ekonomik dönüşümüne dijital yenilik ve mükemmeliyet yoluyla gururla katkıda bulunuyoruz.",
        feature2Title: "Seviye 1 B-BBEE Sertifikalı",
        feature2Description: "Geniş Tabanlı Siyah Ekonomik Güçlendirme standartlarına en yüksek uyum seviyesi.",
        feature3Title: "Yerel Uzmanlık, Küresel Standartlar",
        feature3Description: "Yerel iş bağlamlarını derinlemesine anlayarak dünya standartlarında BT çözümleri sunuyoruz.",
        feature4Title: "Beceri Geliştirme Taahhüdü",
        feature4Description: "Yeteneklere yatırım yaparak ve Güney Afrika'nın dijital beceri ekosistemine katkıda bulunarak.",
        videoAlt: "Hakkımızda Arka Plan",
        videoLink: "Videoyu İzle",
      },
      contactInfo: {
        freeConsultation: "ücretsiz danışmanlık",
        freeConsultationDescription: "Uzmanımızla Ücretsiz Danışmanlık Planlayın",
        scheduleNow: "şimdi planla",
        request: "talep",
        requestDescription: "Deneyimli Profesyonellerle Maceranıza Başlayın",
        sendRequest: "talep gönder",
        helpDesk: "yardım masası",
        helpDeskDescription: "Sorularınız mı var veya daha fazla bilgi mi istiyorsunuz?",
        callNow: "Şimdi Ara",
        phoneNumber: "+41 300 60 88", // Updated phone number
      },
      aboutShort: {
        subHeading: "biz kimiz",
        heading: "Yenilikçi Çözümlerle Geleceğe Yön Veriyoruz",
        description: "İsviçre merkezli bir yazılım şirketi olarak, Türkiye'deki şubemizle farklı sektörlere özel teknoloji çözümleri sunuyoruz. Global deneyimimizle, yerel pazarda inovatif yazılım çözümleri geliştirerek, müşterilerimizin dijital dönüşüm süreçlerine hız katıyoruz. ",
        feature1: "Yazılım geliştirme ve veri analitiği konusunda uzmanlaşmış",
        feature2: "İş sistemleriniz arasında sorunsuz bağlantı",
        feature3: "Dijital pazarlama ve iş zekası hizmetleri",
        feature4: "Ekonomik dönüşüm ve beceri geliştirme taahhüdü",
        moreAboutUs: "hakkımızda daha fazla",
      },
      brand:{
        subHeading: "tüm sektörlere hizmet veriyoruz",
        heading: "Hizmet alanlarımız",
        industry1: "Seyahat ve Turizm",
        industry2: "Bankacılık ve Finans",
        industry3: "Medya ve Eğlence",
        industry4: "Oteller ve Restoranlar",
        industry5: "Sağlık Çözümleri",
        industry6: "E-öğrenme ve Eğitim",
        industry7: "Web Geliştirme",
      },
      cards:{
        card1: "Çapraz Sektör Çözümleri",
        card2: "Alanında Liderlik",
        card3: "Özel Teknoloji Çözümleri",
      },
      footer:{
        headquarter: "Genel Merkez",
        branch: "Şube", 
        address1: "Glattalstrasse 76 8052, Zürich/İsviçre", // Updated address
        address2: "Armağanevler mah., Mithatpaşa cad., no 144, d 1,  Ümraniye, İstanbul/Türkiye",
        email: "info@alpinesoft.ai",
        phone1: "+41 300 60 88", // Updated phone number
        phone2: "+90 532 622 80 07",
        servicesTitle: "Hizmetler",
        service1: "Yazılım Geliştirme",
        service2: "İş Zekası",
        service3: "Sistem Entegrasyonu",
        service4: "Veri Analitiği",
        quickLinksTitle: "Hızlı Bağlantılar",
        quickLink1: "Hakkımızda",
        quickLink2: "Hizmetler",
        quickLink3: "Kariyer",
        quickLink4: "Bize Ulaşın",
        quickLink5: "Gizlilik Politikası",
        copyright: `Telif Hakkı © ${new Date().getFullYear()} AlpineSoft, Tüm Hakları Saklıdır.`,
        backToTop: "Yukarı Çık",
      },
      header: {
        home: "Ana Sayfa",
        about: "Hakkımızda",
        services: "Hizmetler",
        careers: "Kariyer",
        contact: "İletişim",
        freeQuote: "ücretsiz teklif",
        searchPlaceholder: "Burada Ara",
        aboutUsTitle: "Hakkımızda",
        aboutUsDescription: "Yazılım geliştirme, veri analitiği uzmanlığımızla tanınan dinamik bir şirketiz. Deneyimli profesyonellerden oluşan ekibimiz, çeşitli iş ihtiyaçlarını karşılamak için yenilikçi ve kullanıcı odaklı yazılım çözümleri geliştirmede mükemmeldir. Bize katılmak, yaratıcılığı, iş birliğini ve sürekli öğrenmeyi değer veren ileri görüşlü bir organizasyonun parçası olmak anlamına gelir.",
        contactUsTitle: "Bize Ulaşın",
        address: "Glattalstrasse 76 8052, Zürich/İsviçre", // Updated address
        phone: "+41 300 60 88", // Updated phone number
        email: "info@alpinesoft.ai",
      },
      getQuote:{
        subHeading: "ücretsiz teklif al",
        heading: "Hızlı bir sorunuz mu var?",
        nameLabel: "Ad *",
        namePlaceholder: "Devon Lane",
        companyLabel: "Şirket *",
        companyPlaceholder: "Louis Vuitton..",
        emailLabel: "E-posta *",
        emailPlaceholder: "jackson.graham@example.com",
        subjectLabel: "Konu *",
        subjectPlaceholder: "Web..",
        messageLabel: "Mesaj *",
        messagePlaceholder: "Nulla lorem mollit cupidatat irure.",
        submitButton: "şimdi gönder",
        errorMessage: "Lütfen tüm alanları doldurun.",
        successMessage: "Başvurunuz başarıyla gönderildi. En kısa sürede sizinle iletişime geçeceğiz.",
      },
      hero: {
        title: "Yüksek Dijital Çözümlerle Yeniliği Güçlendirme",
        description: "Teknoloji ve dijital erişimde zirveyi hedefleyen şirketler için güvenilir bir ortak olarak duruyoruz.",
        ourService: "Hizmetlerimiz",
        videoPresentation: "Video Sunumu",
        facebook: "Facebook",
        youtube: "Youtube",
        twitter: "Twitter",
        linkedin: "Linkedin",
        businessGrowth: "%100 İş Büyümesi",
        businessGrowthReviews: "4.9 (1520 İnceleme)",
        happyClients: "Mutlu Müşteriler",
        happyClientsReviews: "4.9 (15k İnceleme)",
      },
      map: {
        // Add keys and translations for Map.js here
      },
      mission:{
        historyTitle: "Tarihimiz",
        historyDescription: "İsviçre merkezli olarak kurulmuş ve tecrübeli uzman kadrosuyla Türkiye ve bir çok ülkede faaliyet göstermeye başlamıştır. Kuruluşumuz, dijital dönüşüm süreçlerine hız katmak ve müşterilerine yenilikçi yazılım çözümleri sunmak amacıyla yola çıkmıştır. ",
        missionTitle: "Misyonumuz",
        missionDescription: "Misyonumuz, inovatif yazılım çözümleri ve dijital dönüşüm hizmetleri ile müşterilerimizin iş süreçlerini daha verimli ve sürdürülebilir hale getirerek, onların dijital geleceğine yön vermektir.",
        visionTitle: "Vizyonumuz",
        visionDescription: "Vizyonumuz, İsviçre, Türkiye ve küresel pazarlarda, sektörel ihtiyaçlara yönelik ileri teknoloji çözümleriyle lider bir yazılım şirketi olmak ve dijital dönüşümü her alanda hızlandırmaktır.",
      },
      service2: {
        subHeading: "hizmetlerimiz",
        heading: "İşletmeniz için BT çözümleri",
        service1: "Yazılım Geliştirme",
        service2: "İş Zekası",
        service3: "Sistem Entegrasyonu",
        service4: "Veri Analitiği"
      },
      serviceDetails: {
        service1Title:"Yazılım Geliştirme",
      service1Description:"İhtiyaçlarınıza özel yazılım geliştirme hizmetleri sunuyoruz. Ölçeklenebilir web ve mobil uygulamalardan kurumsal düzeyde çözümler üretmeye kadar her projeyi verimliliği ve kullanıcı deneyimini optimize edecek şekilde özelleştiriyoruz. Modern teknolojiler ve Agile metodolojilerini kullanarak yüksek kaliteli, güvenli ve geleceğe dönük yazılımlar teslim ediyoruz. Mevcut sistemlerinizi geliştirmek ya da sıfırdan yeni bir çözüm geliştirmek istiyorsanız, vizyonunuzu gerçeğe dönüştürmeye kararlıyız.",
      service2Title:"İş Zekası",
      service2Description:"İş Zekası (BI) hizmetlerimiz, ham verilerinizi harekete geçirilebilir içgörülere dönüştürerek daha iyi iş kararları almanıza yardımcı olur. İleri düzey analizler, gösterge panelleri ve raporlama araçları kullanarak, organizasyonunuzun gerçek zamanlı bilgilere erişmesini, anahtar performans göstergelerini takip etmesini ve gizli trendleri keşfetmesini sağlıyoruz. Operasyonel verimliliği artırmak ya da rekabet avantajı elde etmek istiyorsanız, BI çözümlerimiz stratejik kararlar almak ve büyüme için gereken netlik ve öngörü sağlar.",
      service3Title:"Sistem Entegrasyonu",
      service3Description:"Sistem entegrasyonunda uzmanız, tüm iş uygulamalarınızın, veri kaynaklarınızın ve BT sistemlerinizin sorunsuz bir şekilde çalışmasını sağlıyoruz. Entegrasyon hizmetlerimiz, farklı sistemleri birleştirir, iş akışlarını otomatikleştirir ve veri yalıtımını ortadan kaldırarak genel operasyonel verimliliği artırır. Üçüncü taraf API'lerinden kurumsal platformlara kadar, iş hedeflerinizi destekleyen ve ihtiyaçlarınız geliştikçe ölçeklenebilen uyumlu ve birbirine bağlı bir teknoloji ekosistemi oluşturmak için gereken uzmanlığı sağlıyoruz.",
      service4Title:"Veri Analitiği",
      service4Description:"Veri Analitiği hizmetlerimiz, verilerinizin gücünü kullanarak karar alma süreçlerinizi yönlendirecek ve iş performansınızı artıracak değerli içgörüler elde etmenize yardımcı olur. İstatistiksel analiz, makine öğrenimi ve tahminsel modelleme gibi ileri düzey teknikler kullanarak karmaşık veri setlerini açık ve uygulanabilir bilgilere dönüştürüyoruz. Veri analitiği çözümlerimizle, müşteri davranışları, piyasa trendleri ve operasyonel verimlilikler hakkında derinlemesine bir anlayış elde eder, büyümeyi ve yeniliği destekleyen veri odaklı kararlar alabilirsiniz.",
        servicesSidebarTitle: "Hizmetler",
        service1: "Yazılım Geliştirme",
        service2: "İş Zekası",
        service3: "Sistem Entegrasyonu",
        service4: "Veri Analitiği",
        getQuoteTitle: "Teklif Al",
        getQuoteNamePlaceholder: "Adınızı girin*",
        getQuoteEmailPlaceholder: "E-postanızı girin*",
        getQuoteMessagePlaceholder: "Mesaj*",
        getQuoteSubmitButton: "şimdi gönder",
        companyProfileTitle: "Şirket Profili",
        downloadPdf: "PDF İndir",
        downloadWord: "Word dosyasını indir",
        auditServicesTitle: "Denetim ve güvence hizmetlerimizi keşfedin",
        flexibilityTitle: "Üstün Esneklik",
        flexibilityDescription: "Evde Esneklik Eğitimi ve Germe Egzersizleri.",
        timeSavingTitle: "Zaman Tasarrufu",
        timeSavingDescription: "Bir şey yapmak için genellikle gereken süreyi azaltma.",
        managementTitle: "Yönetim",
        managementDescription: "Yönetim, bir organizasyonun idare bilimidir.",
      },
      services: {
        subHeading: "hizmetlerimiz",
        heading: "İşletmeniz için BT çözümleri",
        service1: "YAZILIM GELİŞTİRME",
        service2: "İŞ ZEKASI",
        service3: "SİSTEM ENTEGRASYONU",
        service4: "VERİ ANALİTİĞİ",
        viewAllServices: "tüm hizmetleri görüntüle",
      },
      support:{
        visitUsTitle: "Bizi Ziyaret Edin",
        visitUsAddress: "Glattalstrasse 76 8052, Zürich/İsviçre", // Updated address
        contactUsTitle: "Bize Ulaşın",
        contactUsPhone: "+41 300 60 88", // Updated phone number
        emailUsTitle: "Bize E-posta Gönderin",
        emailUsAddress: "info@alpinesoft.ai",
      },
      whyChooseUs: {
        subHeading: "neden bizi seçmelisiniz",
        heading: "BT Hizmetlerimizi Neden Seçmelisiniz",
        description: "Global deneyimimiz ve yerel çözümlerimizle sektöre özel yenilikçi yazılımlar sunuyoruz. Sunduğumuz teknoloji çözümleri ile iş süreçlerinizi hızlandırıyor ve verimliliği artırıyoruz. Sürekli gelişim odaklı yaklaşımımızla, geleceğe dönük sürdürülebilir başarı sağlıyoruz.",
        expertiseTitle: "Global Deneyim, Yerel Çözümler",
        expertiseDescription: "Yerel ihtiyaçları anlayarak, her sektöre özel yenilikçi yazılım çözümleri sunuyoruz. Hem global bir bakış açısına sahibiz hem de yerel pazarın dinamiklerini yakından takip ediyoruz.",
        clientCentricTitle: "Müşteri Odaklı Yaklaşım",
        clientCentricDescription: "İş hedeflerinizi ve zorluklarınızı anlamayı önceliklendiriyor, hedeflerinizle mükemmel bir şekilde uyumlu çözümler geliştiriyor ve süreç boyunca olağanüstü destek sağlıyoruz.",
        transformationTitle: "Dönüşüm ve Büyüme",
        transformationDescription: "Tutkumuz ve yenilikçi yaklaşımımız, müşterilerimize sürekli gelişim fırsatları sunuyor. Bizimle çalışarak, iş süreçlerinizi geleceğe taşıyan ve bir adım önde olmanızı sağlayan teknolojik çözümler elde edersiniz.",
      },
      workflow: {
        subHeading: "iş akışımız",
        heading: "Vizyonunuzu güçlü dijital çözümlere dönüştürüyoruz",
        step1Title: "Yeni Fikirler Bulun",
        step1Description: "İş ihtiyaçlarınızı anlamak ve zorluklarınıza yenilikçi çözümler üretmek için iş birliği içinde keşif oturumlarıyla başlıyoruz.",
        step2Title: "Dijital Analiz",
        step2Description: "Uzmanlarımız, fırsatları belirlemek ve stratejik bir uygulama yol haritası oluşturmak için kapsamlı teknik değerlendirmeler ve veri analizleri yapar.",
        step3Title: "Pazarlama Araştırması",
        step3Description: "Çözümlerin rekabetçi, alakalı ve maksimum iş etkisi için konumlandırılmış olmasını sağlamak için pazarınızı ve hedef kitlenizi araştırıyoruz.",
        step4Title: "Ürün Oluşturma",
        step4Description: "Yetenekli geliştirme ekibimiz, kalite, ölçeklenebilirlik ve hedeflerinizle uyum sağlayarak konseptleri hayata geçirmek için çevik metodolojiler kullanır.",
      }
    },
    en: {
      about: {
        title: "ABOUT US",
        subtitle: "We provide flexible IT services",
        whoWeAre: "Who We Are",
        companyName: "AlpineSoft",
        description1: "Our Switzerland-based software company, with its branch in Turkey, provides technology solutions tailored to various industries. We offer innovative services in areas such as software development, digital transformation, cloud technologies, and data analytics, making our clients' business processes more efficient. With our global experience and local solutions, we focus on continuous development and technology to ensure sustainable success for our partners. We make a difference in the business world with our software shaping the future.",
        description2: "Our journey began with a vision to bridge the digital divide and create meaningful technological solutions that empower businesses across various sectors. Today, we stand as a trusted partner for organizations seeking reliable IT services, from software development and data analytics to cybersecurity and digital marketing.",
        description3: "What sets us apart is our commitment to both technical excellence and economic empowerment. Our team of expert professionals brings diverse perspectives and expertise to every project, delivering solutions that are not only technically sound but also aligned with our clients' strategic objectives.",
        feature1Title: "100% Black-Owned Enterprise",
        feature1Description: "Proudly contributing to South Africa's economic transformation through digital innovation and excellence.",
        feature2Title: "Level 1 B-BBEE Certified",
        feature2Description: "Highest level of compliance with Broad-Based Black Economic Empowerment standards.",
        feature3Title: "Local Expertise, Global Standards",
        feature3Description: "Delivering world-class IT solutions with deep understanding of local business contexts.",
        feature4Title: "Commitment to Skills Development",
        feature4Description: "Investing in talent and contributing to South Africa's digital skills ecosystem.",
        videoAlt: "About Us Background",
        videoLink: "Watch Video",
      },
      contactInfo: {
        freeConsultation: "Free Consultation",
        freeConsultationDescription: "Plan a Free Consultation With Our Expert",
        scheduleNow: "Schedule Now",
        request: "Request",
        requestDescription: "Start Your Journey With Experienced Professionals",
        sendRequest: "Send Request",
        helpDesk: "Help Desk",
        helpDeskDescription: "Have questions or need more information?",
        callNow: "Call Now",
        phoneNumber: "+41 300 60 88",
      },
      aboutShort: {
        subHeading: "Who We Are",
        heading: "Shaping the Future with Innovative Solutions",
        description: "As a Switzerland-based software company, we provide technology solutions tailored to various industries with our branch in Turkey. With our global experience, we accelerate our clients' digital transformation processes by developing innovative software solutions in the local market.",
        feature1: "Specialized in software development and data analytics",
        feature2: "Seamless connection between your business systems",
        feature3: "Digital marketing and business intelligence services",
        feature4: "Commitment to economic transformation and skill development",
        moreAboutUs: "More About Us",
      },
      brand:{
        subHeading: "Serving All Industries",
        heading: "Our Service Areas",
        industry1: "Travel and Tourism",
        industry2: "Banking and Finance",
        industry3: "Media and Entertainment",
        industry4: "Hotels and Restaurants",
        industry5: "Healthcare Solutions",
        industry6: "E-learning and Education",
        industry7: "Web Development",
      },
      cards:{
        card1: "Cross-Industry Solutions",
        card2: "Leadership in the Field",
        card3: "Custom Technology Solutions",
      },
      footer:{
        headquarter: "Headquarters",
        branch: "Branch Office",
        address1: "Glattalstrasse 76 8052, Zürich/İsviçre", // Updated address
        address2: "Armağanevler District, Mithatpaşa cad., no 144, d 1,  Ümraniye, İstanbul/Turkey",
        email: "info@alpinesoft.ai",
        phone1: "+41 300 60 88", // Updated phone number
        phone2: "+90 532 622 80 07",
        servicesTitle: "Services",
        service1: "Software Development",
        service2: "Business Intelligence",
        service3: "System Integration",
        service4: "Data Analytics",
        quickLinksTitle: "Quick Links",
        quickLink1: "About Us",
        quickLink2: "Services",
        quickLink3: "Careers",
        quickLink4: "Contact Us",
        quickLink5: "Privacy Policy",
        copyright: `Copyright © ${new Date().getFullYear()} AlpineSoft, All Rights Reserved.`,
        backToTop: "Back to Top",
      },
      header: {
        home: "Home",
        about: "About Us",
        services: "Services",
        careers: "Careers",
        contact: "Contact",
        freeQuote: "Free Quote",
        searchPlaceholder: "Search Here",
        aboutUsTitle: "About Us",
        aboutUsDescription: "We are a dynamic company known for our expertise in software development and data analytics. Our team of experienced professionals excels in developing innovative and user-centric software solutions to meet diverse business needs. Joining us means being part of a forward-thinking organization that values creativity, collaboration, and continuous learning.",
        contactUsTitle: "Contact Us",
        address: "Glattalstrasse 76 8052, Zürich/Switzerland",
        phone: "+41 300 60 88",
        email: "info@alpinesoft.ai",
      },
      getQuote:{
        subHeading: "Get a Free Quote",
        heading: "Have a Quick Question?",
        nameLabel: "Name *",
        namePlaceholder: "Devon Lane",
        companyLabel: "Company *",
        companyPlaceholder: "Louis Vuitton..",
        emailLabel: "Email *",
        emailPlaceholder: "jackson.graham@example.com",
        subjectLabel: "Subject *",
        subjectPlaceholder: "Web..",
        messageLabel: "Message *",
        messagePlaceholder: "Nulla lorem mollit cupidatat irure.",
        submitButton: "Submit Now",
        errorFillBlanks: "Please fill in all fields.",
        successMessage: "Your application has been successfully submitted. We will contact you shortly.",
      },
      hero: {
        title: "Empowering Innovation with High Digital Solutions",
        description: "We stand as a trusted partner for companies aiming for the pinnacle in technology and digital access.",
        ourService: "Our Services",
        videoPresentation: "Video Presentation",
        facebook: "Facebook",
        youtube: "Youtube",
        twitter: "Twitter",
        linkedin: "Linkedin",
        businessGrowth: "100% Business Growth",
        businessGrowthReviews: "4.9 (1520 Reviews)",
        happyClients: "Happy Clients",
        happyClientsReviews: "4.9 (15k Reviews)",
      },
      map: {
        // Add keys and translations for Map.js here
      },
      mission:{
        historyTitle: "Our History",
        historyDescription: "Founded in Switzerland and started operating in Turkey and many other countries with its experienced expert staff. Our establishment set out to accelerate digital transformation processes and provide innovative software solutions to its customers.",
        missionTitle: "Our Mission",
        missionDescription: "Our mission is to make our clients' business processes more efficient and sustainable with innovative software solutions and digital transformation services, guiding their digital future.",
        visionTitle: "Our Vision",
        visionDescription: "Our vision is to be a leading software company in Switzerland, Turkey, and global markets with advanced technology solutions tailored to sectoral needs and to accelerate digital transformation in every field.",
      },
      service2: {
        subHeading: "Our Services",
        heading: "IT Solutions for Your Business",
        service1: "Software Development",
        service2: "Business Intelligence",
        service3: "System Integration",
        service4: "Data Analytics",
      },
      serviceDetails: {
        service1Title:"Software Development",
        service1Description:"We provide custom software development services that cater to your unique business needs. From designing scalable web and mobile applications to building enterprise-level solutions, our team ensures that each project is tailored to optimize efficiency and user experience. We utilize modern technologies and Agile methodologies to deliver high-quality, secure, and future-proof software. Whether you're looking to enhance your existing systems or develop a new solution from the ground up, we are committed to turning your vision into reality.",
        service2Title:"Business Intelligence",
        service2Description:"Our Business Intelligence (BI) services help you transform raw data into actionable insights that drive better business decisions. By utilizing advanced analytics, dashboards, and reporting tools, we enable your organization to access real-time information, track key performance indicators, and uncover hidden trends. Whether you're looking to improve operational efficiency or gain a competitive edge, our BI solutions provide the clarity and foresight needed for strategic decision-making and growth.",
        service3Title:"System Integration",
        service3Description:"We specialize in system integration, ensuring that all your business applications, data sources, and IT systems work seamlessly together. Our integration services connect disparate systems, automate workflows, and eliminate data silos, improving overall operational efficiency. From third-party APIs to enterprise platforms, we provide the expertise to create a cohesive and interconnected technology ecosystem that supports your business goals and scales as your needs evolve.",
        service4Title:"Data Analytics",
        service4Description:"Our Data Analytics services help you harness the power of your data to uncover valuable insights that can inform decision-making and drive business performance. We apply advanced techniques, including statistical analysis, machine learning, and predictive modeling, to turn complex data sets into clear, actionable information. With our data analytics solutions, you'll gain a deeper understanding of customer behavior, market trends, and operational efficiencies, allowing you to make data-driven decisions that fuel growth and innovation.",
        servicesSidebarTitle: "Services",
        service1: "Software Development",
        service2: "Business Intelligence",
        service3: "System Integration",
        service4: "Data Analytics",
        getQuoteTitle: "Get a Quote",
        getQuoteNamePlaceholder: "Enter your name*",
        getQuoteEmailPlaceholder: "Enter your email*",
        getQuoteMessagePlaceholder: "Message*",
        getQuoteSubmitButton: "Submit Now",
        companyProfileTitle: "Company Profile",
        downloadPdf: "Download PDF",
        downloadWord: "Download Word File",
        auditServicesTitle: "Explore our audit and assurance services",
        flexibilityTitle: "Superior Flexibility",
        flexibilityDescription: "Flexibility Training and Stretching Exercises at Home.",
        timeSavingTitle: "Time Saving",
        timeSavingDescription: "Reducing the time usually required to do something.",
        managementTitle: "Management",
        managementDescription: "Management is the science of administering an organization.",
      },
      services: {
        subHeading: "Our Services",
        heading: "IT Solutions for Your Business",
        service1: "SOFTWARE DEVELOPMENT",
        service2: "BUSINESS INTELLIGENCE",
        service3: "SYSTEM INTEGRATIONS",
        service4: "DATA ANALYTICS",
        viewAllServices: "View All Services",
      },
      support:{
        visitUsTitle: "Visit Us",
        visitUsAddress: "Glattalstrasse 76 8052, Zürich/Switzerland",
        contactUsTitle: "Contact Us",
        contactUsPhone: "+41 300 60 88",
        emailUsTitle: "Email Us",
        emailUsAddress: "info@alpinesoft.ai",
      },
      whyChooseUs: {
        subHeading: "Why Choose Us",
        heading: "Why Choose Our IT Services",
        description: "We offer innovative software tailored to industry-specific needs with our global experience and local solutions. Our technology solutions accelerate your business processes and increase efficiency. With our continuous improvement-focused approach, we ensure sustainable success for the future.",
        expertiseTitle: "Global Experience, Local Solutions",
        expertiseDescription: "We offer innovative software solutions tailored to each industry by understanding local needs. We have both a global perspective and closely follow the dynamics of the local market.",
        clientCentricTitle: "Client-Centric Approach",
        clientCentricDescription: "We prioritize understanding your business goals and challenges, developing solutions that perfectly align with your objectives, and providing exceptional support throughout the process.",
        transformationTitle: "Transformation and Growth",
        transformationDescription: "Our passion and innovative approach offer continuous improvement opportunities to our clients. By working with us, you gain technological solutions that carry your business processes into the future and keep you one step ahead.",
      },
      workflow: {
        subHeading: "Our Workflow",
        heading: "Transforming Your Vision into Powerful Digital Solutions",
        step1Title: "Discover New Ideas",
        step1Description: "We start with collaborative discovery sessions to understand your business needs and generate innovative solutions to your challenges.",
        step2Title: "Digital Analysis",
        step2Description: "Our experts conduct comprehensive technical assessments and data analyses to identify opportunities and create a strategic implementation roadmap.",
        step3Title: "Market Research",
        step3Description: "We research your market and target audience to ensure solutions are competitive, relevant, and positioned for maximum business impact.",
        step4Title: "Product Creation",
        step4Description: "Our talented development team uses agile methodologies to bring concepts to life, ensuring quality, scalability, and alignment with your goals.",
      }
    },
    de: {
      about: {
        title: "ÜBER UNS",
        subtitle: "Wir bieten flexible IT-Dienstleistungen an",
        whoWeAre: "Wer Wir Sind",
        companyName: "AlpineSoft",
        description1: "Unser in der Schweiz ansässiges Softwareunternehmen bietet mit seiner Niederlassung in der Türkei branchenspezifische Technologielösungen an. Wir bieten innovative Dienstleistungen in Bereichen wie Softwareentwicklung, digitale Transformation, Cloud-Technologien und Datenanalytik, um die Geschäftsprozesse unserer Kunden effizienter zu gestalten. Mit unserer globalen Erfahrung und lokalen Lösungen konzentrieren wir uns auf kontinuierliche Entwicklung und Technologie, um unseren Partnern nachhaltigen Erfolg zu sichern. Mit unserer Software, die die Zukunft gestaltet, setzen wir Maßstäbe in der Geschäftswelt.",
        description2: "Unsere Reise begann mit der Vision, die digitale Kluft zu überbrücken und sinnvolle technologische Lösungen zu schaffen, die Unternehmen in verschiedenen Branchen stärken. Heute sind wir ein vertrauenswürdiger Partner für Organisationen, die zuverlässige IT-Dienstleistungen suchen, von Softwareentwicklung und Datenanalyse bis hin zu Cybersicherheit und digitalem Marketing.",
        description3: "Was uns auszeichnet, ist unser Engagement für technische Exzellenz und wirtschaftliche Stärkung. Unser Team aus qualifizierten Fachleuten bringt vielfältige Perspektiven und spezialisiertes Fachwissen in jedes Projekt ein und sorgt für Lösungen, die nicht nur technisch fundiert, sondern auch auf die strategischen Ziele unserer Kunden abgestimmt sind.",
        feature1Title: "100% Schwarzes Eigentum",
        feature1Description: "Stolz auf unseren Beitrag zur wirtschaftlichen Transformation Südafrikas durch digitale Innovation und Exzellenz.",
        feature2Title: "Level 1 B-BBEE Zertifiziert",
        feature2Description: "Höchstes Maß an Konformität mit den Standards der breiten schwarzen wirtschaftlichen Stärkung.",
        feature3Title: "Lokale Expertise, Globale Standards",
        feature3Description: "Bereitstellung von IT-Lösungen auf Weltklasseniveau mit tiefem Verständnis für lokale Geschäftskontexte.",
        feature4Title: "Engagement für Kompetenzentwicklung",
        feature4Description: "Investition in Talente und Beitrag zum digitalen Kompetenzökosystem Südafrikas.",
        videoAlt: "Über Uns Hintergrund",
        videoLink: "Video Ansehen",
      },
      contactInfo: {
        freeConsultation: "Kostenlose Beratung",
        freeConsultationDescription: "Planen Sie eine kostenlose Beratung mit unserem Experten",
        scheduleNow: "Jetzt Planen",
        request: "Anfrage",
        requestDescription: "Beginnen Sie Ihre Reise mit erfahrenen Fachleuten",
        sendRequest: "Anfrage Senden",
        helpDesk: "Helpdesk",
        helpDeskDescription: "Haben Sie Fragen oder benötigen Sie weitere Informationen?",
        callNow: "Jetzt Anrufen",
        phoneNumber: "+41 300 60 88",
      },
      aboutShort: {
        subHeading: "Wer Wir Sind",
        heading: "Mit Innovativen Lösungen die Zukunft Gestalten",
        description: "Als in der Schweiz ansässiges Softwareunternehmen bieten wir mit unserer Niederlassung in der Türkei branchenspezifische Technologielösungen an. Mit unserer globalen Erfahrung beschleunigen wir die digitalen Transformationsprozesse unserer Kunden, indem wir innovative Softwarelösungen auf dem lokalen Markt entwickeln.",
        feature1: "Spezialisiert auf Softwareentwicklung und Datenanalyse",
        feature2: "Nahtlose Verbindung Ihrer Geschäftssysteme",
        feature3: "Dienstleistungen im Bereich digitales Marketing und Business Intelligence",
        feature4: "Engagement für wirtschaftliche Transformation und Kompetenzentwicklung",
        moreAboutUs: "Mehr Über Uns",
      },
      brand:{
        subHeading: "Dienstleistungen für Alle Branchen",
        heading: "Unsere Dienstleistungsbereiche",
        industry1: "Reisen und Tourismus",
        industry2: "Banken und Finanzen",
        industry3: "Medien und Unterhaltung",
        industry4: "Hotels und Restaurants",
        industry5: "Gesundheitslösungen",
        industry6: "E-Learning und Bildung",
        industry7: "Webentwicklung",
      },
      cards:{
        card1: "Branchenübergreifende Lösungen",
        card2: "Führend in der Branche",
        card3: "Maßgeschneiderte Technologielösungen",
      },
      footer:{
        headquarter: "Hauptsitz",
        branch: "Niederlassung",  
        address1: "Glattalstrasse 76 8052, Zürich/Schweiz",
        email: "info@alpinesoft.ai",
        phone1: "+41 300 60 88",
        address2: "Armaganevler mah., Mithatpaşa cad., no 144, d 1,  Ümraniye, İstanbul/Türkei",
        phone2: "+90 532 622 80 07",
        email: "info@alpinesoft.ai",
        servicesTitle: "Dienstleistungen",
        service1: "SOFTWARE DEVELOPMENT",
        service2: "BUSINESS INTELLIGENCE",
        service3: "SYSTEM INTEGRATIONS",
        service4: "DATA ANALYTICS",
        quickLinksTitle: "Schnellzugriff",
        quickLink1: "Über Uns",
        quickLink2: "Dienstleistungen",
        quickLink3: "Karriere",
        quickLink4: "Kontakt",
        quickLink5: "Datenschutzrichtlinie",
        copyright: `Copyright © ${new Date().getFullYear()} AlpineSoft, Alle Rechte Vorbehalten.`,
        backToTop: "Nach Oben",
      },
      header: {
        home: "Startseite",
        about: "Über Uns",
        services: "Dienstleistungen",
        careers: "Karriere",
        contact: "Kontakt",
        freeQuote: "Kostenloses Angebot",
        searchPlaceholder: "Hier Suchen",
        aboutUsTitle: "Über Uns",
        aboutUsDescription: "Wir sind ein dynamisches Unternehmen, das für seine Expertise in der Softwareentwicklung und Datenanalyse bekannt ist. Unser Team aus erfahrenen Fachleuten zeichnet sich durch die Entwicklung innovativer und benutzerzentrierter Softwarelösungen aus, die den unterschiedlichen Geschäftsanforderungen gerecht werden. Wenn Sie sich uns anschließen, werden Sie Teil einer zukunftsorientierten Organisation, die Kreativität, Zusammenarbeit und kontinuierliches Lernen schätzt.",
        contactUsTitle: "Kontakt",
        address: "Glattalstrasse 76 8052, Zürich/Schweiz",
        phone: "+41 300 60 88",
        email: "info@alpinesoft.ai",
      },
      getQuote:{
        subHeading: "Kostenloses Angebot Einholen",
        heading: "Haben Sie eine Schnelle Frage?",
        nameLabel: "Name *",
        namePlaceholder: "Devon Lane",
        companyLabel: "Unternehmen *",
        companyPlaceholder: "Louis Vuitton..",
        emailLabel: "E-Mail *",
        emailPlaceholder: "jackson.graham@example.com",
        subjectLabel: "Betreff *",
        subjectPlaceholder: "Web..",
        messageLabel: "Nachricht *",
        messagePlaceholder: "Nulla lorem mollit cupidatat irure.",
        submitButton: "Jetzt Absenden",
        errorFillBlanks: "Bitte füllen Sie alle Felder aus.",
        successMessage: "Vielen Dank für Ihre Anfrage! Wir werden uns in Kürze bei Ihnen melden.",
      },
      hero: {
        title: "Innovation mit Hochwertigen Digitalen Lösungen Fördern",
        description: "Wir sind ein vertrauenswürdiger Partner für Unternehmen, die in Technologie und digitalem Zugang die Spitze erreichen wollen.",
        ourService: "Unsere Dienstleistungen",
        videoPresentation: "Video Präsentation",
        facebook: "Facebook",
        youtube: "Youtube",
        twitter: "Twitter",
        linkedin: "Linkedin",
        businessGrowth: "100% Geschäftswachstum",
        businessGrowthReviews: "4.9 (1520 Bewertungen)",
        happyClients: "Zufriedene Kunden",
        happyClientsReviews: "4.9 (15k Bewertungen)",
      },
      map: {
        // Add keys and translations for Map.js here
      },
      mission:{
        historyTitle: "Unsere Geschichte",
        historyDescription: "Gegründet in der Schweiz und mit seinem erfahrenen Expertenteam in der Türkei und vielen anderen Ländern tätig. Unser Unternehmen hat sich zum Ziel gesetzt, digitale Transformationsprozesse zu beschleunigen und seinen Kunden innovative Softwarelösungen anzubieten.",
        missionTitle: "Unsere Mission",
        missionDescription: "Unsere Mission ist es, die Geschäftsprozesse unserer Kunden mit innovativen Softwarelösungen und digitalen Transformationsdiensten effizienter und nachhaltiger zu gestalten und ihre digitale Zukunft zu gestalten.",
        visionTitle: "Unsere Vision",
        visionDescription: "Unsere Vision ist es, ein führendes Softwareunternehmen in der Schweiz, der Türkei und den globalen Märkten zu sein, das fortschrittliche Technologie-Lösungen anbietet, die auf die Bedürfnisse der Branche zugeschnitten sind, und die digitale Transformation in allen Bereichen zu beschleunigen.",
      },
      service2: {
        subHeading: "Unsere Dienstleistungen",
        heading: "IT-Lösungen für Ihr Unternehmen",
        service1: "SOFTWAREENTWICKLUNG",
        service2: "BUSINESS INTELLIGENCE",
        service3: "SYSTEMINTEGRATIONEN ",
        service4: "DATENANALYSE"
      },
      serviceDetails: {
        service1Title:"Softwareentwicklung",
        service1Description:"Wir bieten maßgeschneiderte Softwareentwicklungsdienste, die auf die spezifischen Bedürfnisse Ihres Unternehmens zugeschnitten sind. Vom Design skalierbarer Web- und mobiler Anwendungen bis hin zur Entwicklung von Lösungen auf Unternehmensebene sorgt unser Team dafür, dass jedes Projekt optimiert wird, um Effizienz und Benutzererfahrung zu maximieren. Wir nutzen moderne Technologien und agile Methoden, um qualitativ hochwertige, sichere und zukunftssichere Software zu liefern. Ob Sie bestehende Systeme verbessern oder eine neue Lösung von Grund auf entwickeln möchten, wir setzen uns dafür ein, Ihre Vision in die Realität umzusetzen.",
        service2Title:"Business Intelligence",
        service2Description:"Unsere Business Intelligence (BI)-Dienste helfen Ihnen, Rohdaten in umsetzbare Erkenntnisse umzuwandeln, die bessere Geschäftsentscheidungen vorantreiben. Durch den Einsatz fortschrittlicher Analysetools, Dashboards und Reporting-Tools ermöglichen wir es Ihrem Unternehmen, Echtzeitinformationen abzurufen, wichtige Leistungskennzahlen zu verfolgen und verborgene Trends zu entdecken. Ob Sie die betriebliche Effizienz verbessern oder einen Wettbewerbsvorteil erlangen möchten, unsere BI-Lösungen bieten die Klarheit und Weitsicht, die für strategische Entscheidungen und Wachstum erforderlich sind.",
        service3Title:"Systemintegration",
        service3Description:"Wir sind auf Systemintegration spezialisiert und sorgen dafür, dass alle Ihre Geschäftsanwendungen, Datenquellen und IT-Systeme nahtlos zusammenarbeiten. Unsere Integrationsdienste verbinden unterschiedliche Systeme, automatisieren Arbeitsabläufe und beseitigen Datensilos, wodurch die gesamte betriebliche Effizienz verbessert wird. Von Drittanbieter-APIs bis hin zu Unternehmensplattformen bieten wir das Fachwissen, um ein kohärentes und miteinander verbundenes Technologie-Ökosystem zu schaffen, das Ihre Geschäftsziele unterstützt und mit Ihren wachsenden Anforderungen skaliert.",
        service4Title:"Datenanalyse",
        service4Description:"Unsere Datenanalyse-Dienste helfen Ihnen, die Power Ihrer Daten zu nutzen, um wertvolle Erkenntnisse zu gewinnen, die Entscheidungsprozesse informieren und die Geschäftsergebnisse vorantreiben. Wir wenden fortschrittliche Techniken an, einschließlich statistischer Analysen, maschinellem Lernen und prädiktiver Modellierung, um komplexe Datensätze in klare, umsetzbare Informationen zu verwandeln. Mit unseren Datenanalyse-Lösungen gewinnen Sie ein tieferes Verständnis für Kundenverhalten, Markttrends und betriebliche Effizienzen, was Ihnen ermöglicht, datengestützte Entscheidungen zu treffen, die Wachstum und Innovation fördern.",
        servicesSidebarTitle: "Dienstleistungen",
        service1: "Softwareentwicklung",
        service2: "Unternehmensintelligenz",
        service3: "Systemintegrationen",
        service4: "Datenanalyse",
        getQuoteTitle: "Angebot Einholen",
        getQuoteNamePlaceholder: "Geben Sie Ihren Namen ein*",
        getQuoteEmailPlaceholder: "Geben Sie Ihre E-Mail ein*",
        getQuoteMessagePlaceholder: "Nachricht*",
        getQuoteSubmitButton: "Jetzt Absenden",
        companyProfileTitle: "Unternehmensprofil",
        downloadPdf: "PDF Herunterladen",
        downloadWord: "Word-Datei Herunterladen",
        auditServicesTitle: "Entdecken Sie unsere Prüfungs- und Sicherungsdienste",
        flexibilityTitle: "Überlegene Flexibilität",
        flexibilityDescription: "Flexibilitätstraining und Dehnübungen zu Hause.",
        timeSavingTitle: "Zeitersparnis",
        timeSavingDescription: "Reduzierung der normalerweise erforderlichen Zeit für etwas.",
        managementTitle: "Management",
        managementDescription: "Management ist die Wissenschaft der Verwaltung einer Organisation.",
      },
      services: {
        subHeading: "Unsere Dienstleistungen",
        heading: "IT-Lösungen für Ihr Unternehmen",
        service1: "SOFTWAREENTWICKLUNG",
        service2: "BUSINESS INTELLIGENCE",
        service3: "SYSTEMINTEGRATIONEN ",
        service4: "DATENANALYSE",
        viewAllServices: "Alle Dienstleistungen Ansehen",
      },
      support:{
        visitUsTitle: "Besuchen Sie Uns",
        visitUsAddress: "Glattalstrasse 76 8052, Zürich/Schweiz",
        contactUsTitle: "Kontakt",
        contactUsPhone: "+41 300 60 88",
        emailUsTitle: "E-Mail",
        emailUsAddress: "info@alpinesoft.ai",
      },
      whyChooseUs: {
        subHeading: "Warum Uns Wählen",
        heading: "Warum Unsere IT-Dienstleistungen Wählen",
        description: "Wir bieten innovative Software, die auf branchenspezifische Bedürfnisse zugeschnitten ist, mit unserer globalen Erfahrung und lokalen Lösungen. Unsere Technologielösungen beschleunigen Ihre Geschäftsprozesse und steigern die Effizienz. Mit unserem kontinuierlichen Verbesserungsansatz sorgen wir für nachhaltigen Erfolg in der Zukunft.",
        expertiseTitle: "Globale Erfahrung, Lokale Lösungen",
        expertiseDescription: "Wir bieten innovative Softwarelösungen, die auf die Bedürfnisse jeder Branche zugeschnitten sind, indem wir lokale Bedürfnisse verstehen. Wir haben sowohl eine globale Perspektive als auch ein tiefes Verständnis für die Dynamik des lokalen Marktes.",
        clientCentricTitle: "Kundenorientierter Ansatz",
        clientCentricDescription: "Wir priorisieren das Verständnis Ihrer Geschäftsziele und Herausforderungen, entwickeln Lösungen, die perfekt mit Ihren Zielen übereinstimmen, und bieten während des gesamten Prozesses außergewöhnliche Unterstützung.",
        transformationTitle: "Transformation und Wachstum",
        transformationDescription: "Unsere Leidenschaft und unser innovativer Ansatz bieten unseren Kunden kontinuierliche Verbesserungsmöglichkeiten. Durch die Zusammenarbeit mit uns erhalten Sie technologische Lösungen, die Ihre Geschäftsprozesse in die Zukunft tragen und Sie einen Schritt voraus halten.",
      },
      workflow: {
        subHeading: "Unser Arbeitsablauf",
        heading: "Ihre Vision in Leistungsstarke Digitale Lösungen Umsetzen",
        step1Title: "Neue Ideen Entdecken",
        step1Description: "Wir beginnen mit kollaborativen Entdeckungssitzungen, um Ihre Geschäftsanforderungen zu verstehen und innovative Lösungen für Ihre Herausforderungen zu entwickeln.",
        step2Title: "Digitale Analyse",
        step2Description: "Unsere Experten führen umfassende technische Bewertungen und Datenanalysen durch, um Chancen zu identifizieren und eine strategische Implementierungs-Roadmap zu erstellen.",
        step3Title: "Marktforschung",
        step3Description: "Wir recherchieren Ihren Markt und Ihre Zielgruppe, um sicherzustellen, dass die Lösungen wettbewerbsfähig, relevant und für maximale Geschäftsauswirkungen positioniert sind.",
        step4Title: "Produkterstellung",
        step4Description: "Unser talentiertes Entwicklungsteam verwendet agile Methoden, um Konzepte zum Leben zu erwecken und dabei Qualität, Skalierbarkeit und Übereinstimmung mit Ihren Zielen sicherzustellen.",
      }
    },
  };

  return translations[language]?.[component][key] || key;
};

export default translate;